module.exports = __webpack_public_path__ + "static/media/iphone-text.1224dba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iphone-text.png
// module id = 1425
// module chunks = 0